import { DDDValidator } from 'utils/formatters';

export const isPhone = (value: string): boolean => {
  return /^\d{2}9\d{8}$/.test(value) && DDDValidator(value.slice(0, 2));
};
